import * as Yup from "yup";

export const validatorEmail = Yup.string()
  .trim()
  // normalize emails to standard
  .lowercase()
  .email("Please enter a valid email address");
